var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.75H1.5C1.33424 0.75 1.17527 0.815848 1.05806 0.933058C0.940848 1.05027 0.875 1.20924 0.875 1.375V12C0.875 12.3315 1.0067 12.6495 1.24112 12.8839C1.47554 13.1183 1.79348 13.25 2.125 13.25H15.875C16.2065 13.25 16.5245 13.1183 16.7589 12.8839C16.9933 12.6495 17.125 12.3315 17.125 12V1.375C17.125 1.20924 17.0592 1.05027 16.9419 0.933058C16.8247 0.815848 16.6658 0.75 16.5 0.75ZM14.8906 2L9 7.39844L3.10938 2H14.8906ZM15.875 12H2.125V2.79687L8.57812 8.71094C8.69334 8.81634 8.84384 8.8748 9 8.8748C9.15616 8.8748 9.30666 8.81634 9.42188 8.71094L15.875 2.79687V12Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/Msg.5d0e3cdbb6ccf622045b36438eecae6e.svg";
export { ForwardRef as ReactComponent };